const SECRET = 'roedev';

export class CheatUnlocker {
  private buffer = '';
  private unlocked = false;
  private readonly handler: (e: KeyboardEvent) => void;

  constructor(private readonly onUnlock: () => void) {
    this.handler = (e: KeyboardEvent) => {
      if (this.unlocked) return;
      // Some synthetic/IME keyboard events arrive without `key` set, which
      // crashed the listener and (because it was attached at startup) broke
      // every subsequent keydown in the game. Guard against that first.
      if (typeof e.key !== 'string' || e.key.length !== 1) return; // skip Shift, Enter, IME, etc.
      this.buffer = (this.buffer + e.key).slice(-SECRET.length);
      if (this.buffer === SECRET) {
        this.unlocked = true;
        this.showToast();
        this.onUnlock();
      }
    };
    document.addEventListener('keydown', this.handler);
  }

  private showToast(): void {
    const toast = document.createElement('div');
    toast.textContent = 'Cheat console unlocked!';
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(10, 8, 15, 0.92)',
      color: '#a0ff80',
      fontFamily: 'monospace',
      fontSize: '14px',
      padding: '8px 18px',
      borderRadius: '4px',
      border: '1px solid #4ade80',
      zIndex: '99999',
      pointerEvents: 'none',
    });
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  destroy(): void {
    document.removeEventListener('keydown', this.handler);
  }
}
